import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);    
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    companies() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`consolidasi/company`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tahun', 'kodeacc', 'namaacc'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/consolcoa${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    getmapping(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['compcode', 'company'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/consolcoa/mapping${str}`;
                const {data}= await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    delmapping(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`consolcoa/mapping/${obj.compcode}/${obj.kodeacc}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    templatemapping() {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await axios({
                    url: `/download/mappingconslida`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });        
    },
    exportmapping(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kodeacc', 'namaacc'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                const resp = await axios({
                    url: `/consolcoa/exportmapping${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });                    
    },
    uploadmapping(fileXlsx,obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', fileXlsx, fileXlsx.name);
                // const keys = ['sheetName', 'startRow', 'invoiceno', 'CustCode', 'CustName', 'Address1', 'npwp','npwp_name'];
                for (const key in obj) {

                    // if (keys.indexOf(key) >= 0 && obj[key]) {
                        fd.append(key, obj[key]);
                    // }
                }

                const resp = await axios.post("consolcoa/uploadmapping", fd);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    update(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const obj = {kodelama: data.kodelama, tahunlama: data.tahunlama, tahun: data.tahun, kodeacc: data.kodeacc, namaacc: data.namaacc, typeacc: data.typeacc, tanda_nrc: data.tanda_nrc, awal: data.awal} ;
                await axios.put("consolcoa", obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    insert(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("consolcoa", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("consolcoa/mapping", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`consolcoa/${obj.tahun}/${obj.kodeacc}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tahun', 'kodeacc', 'namaacc'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`/consolcoa/print${str}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    }, 
    exportXls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kodeacc', 'namaacc'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                const resp = await axios({
                    url: `/consolcoa/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });                    
    }
};